import React from "react";
//import styled from 'styled-components';
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

import { Title, Dot } from "../styles/GlobalStyles";

export default function Publikacije() {
  const data = useStaticQuery(graphql`
    {
      program: file(relativePath: { eq: "DV2022-program-naslovnica-www.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, quality: 100, layout: FULL_WIDTH)
        }
      }
      zbornik: file(relativePath: { eq: "DV2022-Zbornik-naslovnica.jpg" }) {
        childImageSharp {
          gatsbyImageData(width: 200, quality: 100, layout: FULL_WIDTH)
        }
      }
    }
  `);
  return (
    <>
      <div className="py-20">
        <div className="mx-auto max-w-screen-lg  xl:max-w-screen-xl">
          <div className="flex flex-wrap">
            <div className="flex w-full flex-col justify-items-center sm:w-1/2">
              <Title className="text-center">
                Program<Dot>.</Dot>
              </Title>
              <div className="flex justify-center">
                <a href="DV-2022-Program.pdf">
                  <GatsbyImage
                    image={data.program.childImageSharp.gatsbyImageData}
                    className="mt-4 block  w-48 border object-center"
                  />
                </a>
              </div>
            </div>
            <div className="flex w-full flex-col justify-items-center sm:w-1/2">
              <Title className="text-center">
                Zbornik<Dot>.</Dot>
              </Title>
              <div className="flex justify-center">
                <a href="https://press.um.si/index.php/ump/catalog/view/683/921/2305-1">
                  <GatsbyImage
                    image={data.zbornik.childImageSharp.gatsbyImageData}
                    className="mt-4 block  w-48 border object-center"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
